import { Switch, Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const PreferencesSwitch = ({ isEditing, state, setState, disabled = false, disabledTooltip = null }) => {
    const { t } = useTranslation("settings");

    if (isEditing) {
        return (
            <Tooltip title={disabledTooltip || (disabled ? t("preferences.stripeRequiredTooltip") : "")}>
                <Switch
                    checked={state}
                    onChange={setState}
                    size="default"
                    checkedChildren={t("enabled")}
                    unCheckedChildren={t("disabled")}
                    disabled={disabled}
                />
            </Tooltip>
        );
    }

    return (
        <Tooltip title={disabledTooltip || t("preferences.statusTooltip")}>
            <Tag color={state ? "success" : "default"}>
                <div className="flex items-center gap-2">
                    <div className={`w-2 h-2 rounded-full ${state ? "bg-[#0A8754] animate-pulse" : "bg-gray-400"}`} />
                    <span className={`${state ? "text-[#0A8754]" : "text-gray-600"} font-medium`}>
                        {t(state ? "enabled" : "disabled")}
                    </span>
                </div>
            </Tag>
        </Tooltip>
    );
};

PreferencesSwitch.propTypes = {
    isEditing: PropTypes.bool.isRequired,
    state: PropTypes.bool.isRequired,
    setState: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.string,
};

export default PreferencesSwitch;
